import { render } from "./Main.vue?vue&type=template&id=770affdd"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"

import exportComponent from "/srv/data/www/krasp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/Main.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "770affdd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('770affdd', __exports__)) {
    api.reload('770affdd', __exports__)
  }
  
  module.hot.accept("./Main.vue?vue&type=template&id=770affdd", () => {
    api.rerender('770affdd', render)
  })

}


export default __exports__